import type { FC, PropsWithChildren } from "react";
import React from "react";

export const AppContainer: FC<PropsWithChildren> = ({ children }) => (
  <div className="flex min-h-screen flex-col bg-background">{children}</div>
);
